import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { IDuplicateLeadMatch } from '../components/types';

export const getDuplicateLeadMatch = async (
    leadId: string
): Promise<IDuplicateLeadMatch> => {
    const response = await ApiV2.get(
        `/leads/duplicate-match/${leadId}`,
        HEADERS({ isReadPermissionNecessary: true })
    );

    return response.data.response;
};
